/**
 * Ruta `/activar` (T020 + US1/T032): formulario del código de activación de 6 símbolos, canje
 * contra `POST /api/v1/terminal/activate` y confirmación "✓ Marcador configurado".
 * La pantalla vive en `features/activation/activation-screen.tsx`.
 */
import { createFileRoute } from '@tanstack/react-router';

import { ActivationScreen } from '../features/activation/activation-screen';

export const Route = createFileRoute('/activar')({
  component: ActivationScreen,
});
